import { Link, useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight, Mail, Bell } from "lucide-react";

const COPY = {
  divorce: { title: "Divorce Packet (NY)", blurb: "Supreme Court header, verified complaint with NY 230 residency language, affidavit of indigency, summons with notice, and service-of-process guidance." },
  immigration: { title: "Immigration Assistance", blurb: "Case summary, personal statement, document checklist, and filing-preparation guide." },
  petition: { title: "Petition Preparation", blurb: "Auto-generated petitions, motions, and court filings tailored to the type you select." },
  hearing: { title: "Hearing Preparation", blurb: "Hearing summary, prepared statement, talking points, and a document checklist — built from a focused intake." },
};

export default function ComingSoon() {
  const params = new URLSearchParams(useLocation().search);
  const svc = params.get("svc") || "service";
  const meta = COPY[svc] || { title: "Coming Soon", blurb: "This service is launching shortly." };

  return (
    <div className="bg-black text-zinc-100 min-h-screen pt-16 pb-24">
      <div className="container-pl max-w-2xl">
        <p className="overline mb-4">Launching soon</p>
        <h1 className="display-serif text-4xl sm:text-5xl text-zinc-50 leading-tight mb-4 accent-rule">
          {meta.title}
        </h1>
        <p className="text-lg text-zinc-300 leading-relaxed mb-8">{meta.blurb}</p>

        <div className="border border-amber-400/30 bg-blue-950/20 rounded-sm p-6 mb-8">
          <div className="flex items-start gap-3 mb-2">
            <Bell className="h-5 w-5 text-amber-400 flex-shrink-0 mt-0.5" strokeWidth={1.5}/>
            <div>
              <p className="font-medium text-zinc-50">Want to be notified at launch?</p>
              <p className="text-sm text-zinc-400 mt-1">Schedule a consultation and we'll prioritize your case as soon as this service is live.</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <Link to="/booking">
            <Button size="lg" className="rounded-sm bg-blue-700 hover:bg-blue-600 text-white">
              <Mail className="mr-2 h-4 w-4" strokeWidth={1.5}/> Schedule a Consultation
            </Button>
          </Link>
          <Link to="/services">
            <Button size="lg" variant="outline" className="rounded-sm border-amber-400 text-amber-400 hover:bg-blue-950/30">
              Back to services <ArrowRight className="ml-2 h-4 w-4"/>
            </Button>
          </Link>
        </div>

        <p className="text-[11px] text-zinc-500 italic mt-10">
          We are not attorneys and do not provide legal advice. All services are administrative document preparation only.
        </p>
      </div>
    </div>
  );
}
